import { render, staticRenderFns } from "./LandDialog.vue?vue&type=template&id=5d1c168c&scoped=true"
import script from "./LandDialog.vue?vue&type=script&lang=js"
export * from "./LandDialog.vue?vue&type=script&lang=js"
import style0 from "./LandDialog.vue?vue&type=style&index=0&id=5d1c168c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c168c",
  null
  
)

export default component.exports